export default function latlngMask(value: string): string {
    let newValue = value
    newValue = newValue.replace(/[^0-9.-]/g, '')
    return newValue
}
